import { Box, Hidden } from 'app/components/marketist';
import css from './publication-quotes.module.css';
type PublicationQuotesProps = {
  children: React.ReactNode;
};
export function PublicationQuotes({
  children
}: PublicationQuotesProps) {
  return <Box className={css.publicationQuotesContainer} data-sentry-element="Box" data-sentry-component="PublicationQuotes" data-sentry-source-file="publication-quotes.tsx">
            <Box className={css.publicationQuotesWrapper} data-sentry-element="Box" data-sentry-source-file="publication-quotes.tsx">
                {children}
                <Hidden above="lg" data-sentry-element="Hidden" data-sentry-source-file="publication-quotes.tsx">
                    {children}
                    {children}
                </Hidden>
            </Box>
        </Box>;
}